import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { TagsDashboardQueryKeys } from "modules/TagsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { toISOString } from "utils/dateHelperFunctions";

import type { Tag } from "models";

export type TagFormPayload = Pick<Tag, "id" | "name" | "color" | "is_system" | "created_on">;

export const useCreateTagMutation = () =>
  useTypedMutation<TagFormPayload, number>({
    mutationFn: async payload => (await ApiInstance.post("/tags/create", payload, ENV.systemBaseURL)).data.tag_id,
    onSuccess: (payload, id) => {
      const tags = typedQueryClient.getQueryData(TagsDashboardQueryKeys.tags);

      const tagIdx = tags?.findIndex(tag => tag.id === id) ?? -1;
      if (tagIdx !== -1) return;

      const now = toISOString(new Date());
      typedQueryClient.setQueryData(TagsDashboardQueryKeys.tags, [{ ...payload, id, created_on: now, updated_on: now }, ...(tags ?? [])]);
    }
  });
